import React from 'react';
import PropTypes from 'prop-types';
import { Accordion, AccordionSummary} from '@mui/material';
import {makeStyles} from '@mui/styles'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

function SMCExpansionPanel({
    title,
    children
}) {
    const classes = useStyles();

    return (
        <Accordion classes={{ root: classes.root, expanded: classes.rootExpanded }}>
            <AccordionSummary classes={{ root: classes.summary, expanded: classes.summaryExpanded }} expandIcon={<ExpandMoreIcon />}>
                {title}
            </AccordionSummary>
            <div className={classes.childrenContainer}>
                {children}
            </div>
        </Accordion>
    );
}

const useStyles = makeStyles({
    root: {
        border: 'none',
        borderBottom: '1px dashed #AAB4C4',
        boxShadow: 'none',
        '&:before': {
          display: 'none',
        },
    },
    rootExpanded: {
        margin: '0px !important'
    },
    summary: {
        height: '40px',
        padding: '0 7px',
        minHeight: '40px',
    },
    summaryExpanded: {
        height: '30x !important',
        minHeight: '30px !important'
    },
    childrenContainer: {
        padding: '10px 0',
        borderTop: '1px solid #AAB4C426',
    }
});

SMCExpansionPanel.propTypes = {
    title: PropTypes.string.isRequired
}

export default SMCExpansionPanel;